import { render, staticRenderFns } from "./Color.vue?vue&type=template&id=696a5831&scoped=true&"
import script from "./Color.vue?vue&type=script&lang=js&"
export * from "./Color.vue?vue&type=script&lang=js&"
import style0 from "./Color.vue?vue&type=style&index=0&id=696a5831&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696a5831",
  null
  
)

export default component.exports